<template>
  <div @click="onClick">
    <slot></slot>
    <a-modal
      v-model="visible"
      width="80vw"
      :footer="null"
      :centered="true"
      :closable="false"
      :maskClosable="false"
      :maskStyle="{ background: '#1c1c1c' }"
      wrapClassName="c-profile-download-modal"
    >
      <div class="c-profile-download">
        <div class="title">
          {{ file.title }}
        </div>
        <div
          class="r1"
          v-if="file.r1"
          @click="onR1Download"
          :style="{ backgroundImage: `url(${images.download_r1})` }"
        >
          <div class="download">
            <i class="iconfont iconxiazai" />
          </div>
        </div>
        <div class="text" v-if="file.r1">
          {{ $t("selectVersion.R1") }}
        </div>
        <div
          class="r2"
          v-if="file.r2"
          @click="onR2Download"
          :style="{ backgroundImage: `url(${images.download_r2})` }"
        >
          <div class="download">
            <i class="iconfont iconxiazai" />
          </div>
        </div>
        <div class="text" v-if="file.r2">
          {{ $t("selectVersion.R2") }}
        </div>
        <div class="buttons">
          <md-button class="button" @click="visible = false">
            {{ $t("back") }}
          </md-button>
        </div>
      </div>
    </a-modal>
    <a-modal
      v-model="selectVisible"
      width="80vw"
      :footer="null"
      :centered="true"
      :closable="false"
      :maskClosable="false"
      :maskStyle="{ background: '#1c1c1c' }"
      wrapClassName="c-turn-modal"
    >
      <div class="c-select" :class="{ cn: isCN }">
        <div class="title">
          {{ $t("selectVersion.select") }}
        </div>
        <md-checkbox v-model="led1" class="checkbox">
          {{ $t("selectVersion.led") }} 1
        </md-checkbox>
        <md-checkbox v-model="led2" class="checkbox">
          {{ $t("selectVersion.led") }} 2
        </md-checkbox>
        <md-checkbox v-model="led3" class="checkbox">
          {{ $t("selectVersion.led") }} 3
        </md-checkbox>
        <md-checkbox v-model="inSwitch1" class="checkbox">
          {{ $t("selectVersion.inSwitch") }} 1
        </md-checkbox>
        <md-checkbox v-model="inSwitch2" class="checkbox">
          {{ $t("selectVersion.inSwitch") }} 2
        </md-checkbox>
        <md-checkbox v-model="inSwitch3" class="checkbox">
          {{ $t("selectVersion.inSwitch") }} 3
        </md-checkbox>
        <md-checkbox v-model="layout" class="checkbox">
          {{ $t("selectVersion.layout") }}
        </md-checkbox>
        <div class="buttons">
          <md-button class="button" @click="selectVisible = false">
            {{ $t("cancel") }}
          </md-button>
          <md-button
            class="button"
            @click="downloadR2"
            :disabled="r2DownloadDisabled"
          >
            {{ $t("yes") }}
          </md-button>
        </div>
      </div>
    </a-modal>
    <a-modal
      v-model="selectOSVisible"
      width="80vw"
      :footer="null"
      :centered="true"
      :closable="false"
      :maskClosable="false"
      :maskStyle="{ background: '#1c1c1c' }"
      wrapClassName="c-turn-modal"
    >
      <div class="c-select">
        <md-checkbox :value="isMac" @change="isMac = false" class="checkbox">
          windows
        </md-checkbox>
        <md-checkbox :value="!isMac" @change="isMac = true" class="checkbox">
          mac
        </md-checkbox>
        <div class="buttons">
          <md-button class="button" @click="selectOSVisible = false">
            {{ $t("cancel") }}
          </md-button>
          <md-button
            class="button"
            @click="
              () => {
                if (isMac) {
                  downloadR2();
                } else {
                  selectVisible = true;
                }
                selectOSVisible = false;
              }
            "
          >
            {{ $t("yes") }}
          </md-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { download, speedList, deepCopy } from "@/utils";
import profileNew from "@/assets/profile-new.json";
import { prepareR6SelectionDownloadData } from "@/views/CyberboardR6/r6Profile";

export default {
  name: "CProfileDownload",
  props: {
    profile: Object,
    profileType: String,
    fileName: String,
    type: String,
    version: String,
    profileFormat: {
      type: String,
      default: "legacy",
    },
  },
  data() {
    return {
      visible: false,
      selectVisible: false,
      led1: true,
      led2: true,
      led3: true,
      inSwitch1: true,
      inSwitch2: true,
      inSwitch3: true,
      layout: true,
      selectOSVisible: false,
      isMac: false,
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("assets", {
      images: "images",
      oss: "oss",
    }),
    file() {
      switch (this.type) {
        case "windows":
          return {
            title: this.$t("selectVersion.application"),
            r1: this.oss.r1Setup,
            r2: this.oss.r2Setup,
          };
        case "mac":
          return {
            title: this.$t("selectVersion.application"),
            r1: false,
            r2: this.oss.r2SetupMac,
          };

        default:
          return {
            title: this.$t("selectVersion.profile"),
            r1: true,
            r2: true,
          };
      }
    },
    r2DownloadDisabled() {
      return (
        !this.led1 &&
        !this.led2 &&
        !this.led3 &&
        !this.inSwitch1 &&
        !this.inSwitch2 &&
        !this.inSwitch3 &&
        !this.layout
      );
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
      if (this.version === "r1") {
        this.onR1Download();
      } else if (this.version === "r2") {
        this.onR2Download();
      } else {
        this.visible = true;
      }
    },
    onR1Download() {
      this.visible = false;
      if (typeof this.file.r1 === "string") {
        download(this.file.r1);
        return;
      }
      let profile = deepCopy(this.profile);
      profile.lightEffects.map((lightEffect) => {
        if (lightEffect.speed && lightEffect.speed.value < 11) {
          lightEffect.speed.value = 11;
        }
        // if (index < 7) {
        //   if (lightEffect.frames) {
        //     lightEffect.frames = lightEffect.frames.slice(0, 60);
        //   }
        // } else {
        //   if (lightEffect.frames) {
        //     lightEffect.frames = lightEffect.frames.slice(0, 26);
        //     if (lightEffect.frames[25]) {
        //       lightEffect.frames[25].frameRGB = lightEffect.frames[25].frameRGB.slice(
        //         0,
        //         40
        //       );
        //     }
        //   }
        // }
      });
      for (let index = 1; index < 7; index++) {
        delete profile["keyboardSettings" + index];
      }
      const file = new Blob([JSON.stringify(profile)]);
      const fileName = (this.fileName + "-CBR1&XMAS.json").replace(
        /-CB.+CB/,
        "-CB"
      );
      download(file, fileName);
    },
    onR2Download() {
      this.visible = false;
      if (typeof this.file.r2 === "string") {
        download(this.file.r2);
        return;
      }
      switch (this.profileType) {
        case "windows":
          this.selectVisible = true;
          break;
        case "mac":
          this.downloadR2();
          break;
        default:
          this.selectOSVisible = true;
          break;
      }
    },
    downloadR2() {
      if (this.profileFormat === "r6") {
        this.downloadR6();
        return;
      }
      const { lightEffects } = this.profile;
      let { page_data } = profileNew;
      let speed = speedList[lightEffects[4].speed.value - 1] || 100;
      speed = speed > 100 ? 100 : speed;
      page_data[5] = {
        ...page_data[5],
        frames: {
          ...this.getFrames(lightEffects[4].frames),
          valid: this.led1 ? 1 : 2,
        },
        speed_ms: speed,
        keyframes: {
          ...this.getKeyFrames(lightEffects[11].frames),
          valid: this.inSwitch1 ? 1 : 2,
        },
      };
      speed = speedList[lightEffects[5].speed.value - 1] || 100;
      speed = speed > 100 ? 100 : speed;
      page_data[6] = {
        ...page_data[6],
        frames: {
          ...this.getFrames(lightEffects[5].frames),
          valid: this.led2 ? 1 : 2,
        },
        speed_ms: speed,
        keyframes: {
          ...this.getKeyFrames(lightEffects[12].frames),
          valid: this.inSwitch2 ? 1 : 2,
        },
      };
      speed = speedList[lightEffects[6].speed.value - 1] || 100;
      speed = speed > 100 ? 100 : speed;
      page_data[7] = {
        ...page_data[7],
        frames: {
          ...this.getFrames(lightEffects[6].frames),
          valid: this.led3 ? 1 : 2,
        },
        speed_ms: speed,
        keyframes: {
          ...this.getKeyFrames(lightEffects[13].frames),
          valid: this.inSwitch3 ? 1 : 2,
        },
      };
      const key_layer = {
        ...this.getKeys(this.profile),
        valid: this.layout ? 1 : 2,
      };

      let data = deepCopy({
        ...profileNew,
        page_data,
        key_layer,
      });

      if (this.profileType === "mac" || this.isMac) {
        const reValid = (object) => {
          for (const key in object) {
            if (key === "valid") {
              object[key] = object[key] === 1 ? true : false;
            }
            if (object[key] && typeof object[key] === "object") {
              console.log(key);
              console.log(typeof object[key]);
              if (
                Array.isArray(object[key]) &&
                object[key].length &&
                typeof object[key][0] === "object" &&
                typeof object[key][0] !== "string" &&
                typeof object[key][0] !== "number"
              ) {
                object[key].map((item, index) => {
                  reValid(object[key][index]);
                });
              } else if (
                !Array.isArray(object[key]) &&
                typeof object[key] === "object"
              ) {
                reValid(object[key]);
              }
            }
          }
        };
        reValid(data);
      }
      const file = new Blob([JSON.stringify(data)]);
      const fileName = (this.fileName + "-CB.json").replace(/-CB.+CB/, "-CB");
      download(file, fileName);
      this.selectVisible = false;
    },
    downloadR6() {
      const data = prepareR6SelectionDownloadData(this.profile, {
        led: [this.led1, this.led2, this.led3],
        axis: [this.inSwitch1, this.inSwitch2, this.inSwitch3],
        keyLayer: this.layout,
      });
      const file = new Blob([JSON.stringify(data)]);
      const fileName = `${this.fileName || "AM"}-CB.json`.replace(
        /-CB.+CB/,
        "-CB"
      );
      download(file, fileName);
      this.selectVisible = false;
    },
    getFrames(frames) {
      let frameData = [];
      frames.map((frame, index) => {
        let frame_RGB = [];
        for (let i = 0; i < 5; i++) {
          for (let j = 0; j < 40; j++) {
            frame_RGB.push(frame.frameRGB[j * 5 + i]);
          }
        }
        frameData.push({
          frame_RGB,
          frame_index: index,
        });
      });
      return {
        frame_data: frameData,
        frame_num: frameData.length,
        valid: true,
      };
    },
    getKeyFrames(frames) {
      let newFrame = [];
      let frameData = [];
      frames.map((frame) => {
        frame.frameRGB.map((RGB) => {
          if (
            !newFrame[newFrame.length - 1] ||
            newFrame[newFrame.length - 1].frameRGB.length === 84
          ) {
            newFrame.push({
              frameIndex: newFrame.length + 1,
              frameRGB: [],
            });
          }
          newFrame[newFrame.length - 1].frameRGB.push(RGB);
        });
      });
      newFrame.map((frame, index) => {
        let frame_RGB = [];
        frame_RGB[0] = frame.frameRGB[1];
        frame_RGB[1] = frame.frameRGB[2];
        frame_RGB[2] = frame.frameRGB[3];
        frame_RGB[3] = frame.frameRGB[4];
        frame_RGB[4] = frame.frameRGB[5];
        frame_RGB[5] = frame.frameRGB[6];
        frame_RGB[6] = frame.frameRGB[7];
        frame_RGB[7] = frame.frameRGB[8];
        frame_RGB[8] = frame.frameRGB[9];
        frame_RGB[9] = frame.frameRGB[10];
        frame_RGB[10] = frame.frameRGB[11];
        frame_RGB[11] = frame.frameRGB[12];
        frame_RGB[12] = frame.frameRGB[13];
        frame_RGB[13] = frame.frameRGB[14];
        frame_RGB[14] = frame.frameRGB[70];

        frame_RGB[15] = frame.frameRGB[15];
        frame_RGB[16] = frame.frameRGB[16];
        frame_RGB[17] = frame.frameRGB[17];
        frame_RGB[18] = frame.frameRGB[18];
        frame_RGB[19] = frame.frameRGB[19];
        frame_RGB[20] = frame.frameRGB[20];
        frame_RGB[21] = frame.frameRGB[21];
        frame_RGB[22] = frame.frameRGB[22];
        frame_RGB[23] = frame.frameRGB[23];
        frame_RGB[24] = frame.frameRGB[24];
        frame_RGB[25] = frame.frameRGB[25];
        frame_RGB[26] = frame.frameRGB[26];
        frame_RGB[27] = frame.frameRGB[27];
        frame_RGB[28] = frame.frameRGB[28];
        frame_RGB[29] = frame.frameRGB[69];

        frame_RGB[30] = frame.frameRGB[29];
        frame_RGB[31] = frame.frameRGB[30];
        frame_RGB[32] = frame.frameRGB[31];
        frame_RGB[33] = frame.frameRGB[32];
        frame_RGB[34] = frame.frameRGB[33];
        frame_RGB[35] = frame.frameRGB[34];
        frame_RGB[36] = frame.frameRGB[35];
        frame_RGB[37] = frame.frameRGB[36];
        frame_RGB[38] = frame.frameRGB[37];
        frame_RGB[39] = frame.frameRGB[38];
        frame_RGB[40] = frame.frameRGB[39];
        frame_RGB[41] = frame.frameRGB[40];
        frame_RGB[42] = frame.frameRGB[41];
        frame_RGB[43] = frame.frameRGB[42];
        frame_RGB[44] = frame.frameRGB[68];

        frame_RGB[45] = frame.frameRGB[43];
        frame_RGB[46] = frame.frameRGB[44];
        frame_RGB[47] = frame.frameRGB[45];
        frame_RGB[48] = frame.frameRGB[46];
        frame_RGB[49] = frame.frameRGB[47];
        frame_RGB[50] = frame.frameRGB[48];
        frame_RGB[51] = frame.frameRGB[49];
        frame_RGB[52] = frame.frameRGB[50];
        frame_RGB[53] = frame.frameRGB[51];
        frame_RGB[54] = frame.frameRGB[52];
        frame_RGB[55] = frame.frameRGB[53];
        frame_RGB[56] = frame.frameRGB[54];
        frame_RGB[57] = "#000000";
        frame_RGB[58] = frame.frameRGB[55];
        frame_RGB[59] = frame.frameRGB[56];

        frame_RGB[60] = frame.frameRGB[57];
        frame_RGB[61] = "#000000";
        frame_RGB[62] = frame.frameRGB[58];
        frame_RGB[63] = frame.frameRGB[59];
        frame_RGB[64] = frame.frameRGB[60];
        frame_RGB[65] = frame.frameRGB[61];
        frame_RGB[66] = frame.frameRGB[62];
        frame_RGB[67] = frame.frameRGB[63];
        frame_RGB[68] = frame.frameRGB[64];
        frame_RGB[69] = frame.frameRGB[65];
        frame_RGB[70] = frame.frameRGB[66];
        frame_RGB[71] = frame.frameRGB[67];
        frame_RGB[72] = frame.frameRGB[82];
        frame_RGB[73] = frame.frameRGB[83];
        frame_RGB[74] = "#000000";

        frame_RGB[75] = frame.frameRGB[71];
        frame_RGB[76] = frame.frameRGB[72];
        frame_RGB[77] = frame.frameRGB[73];
        frame_RGB[78] = "#000000";
        frame_RGB[79] = frame.frameRGB[74];
        frame_RGB[80] = frame.frameRGB[75];
        frame_RGB[81] = frame.frameRGB[76];
        frame_RGB[82] = "#000000";
        frame_RGB[83] = "#000000";
        frame_RGB[84] = "#000000";
        frame_RGB[85] = frame.frameRGB[77];
        frame_RGB[86] = frame.frameRGB[78];
        frame_RGB[87] = frame.frameRGB[79];
        frame_RGB[88] = frame.frameRGB[80];
        frame_RGB[89] = frame.frameRGB[81];
        frameData.push({
          frame_RGB,
          frame_index: index,
        });
      });
      return {
        frame_data: frameData,
        frame_num: frameData.length,
        valid: true,
      };
    },
    getKeys(data) {
      const keyList = [
        { r1: "key_esc", r2: "#00070029", r2Index: 0 },
        { r1: "key_f1", r2: "#0007003A", r2Index: 1 },
        { r1: "key_f2", r2: "#0007003B", r2Index: 2 },
        { r1: "key_f3", r2: "#0007003C", r2Index: 3 },
        { r1: "key_f4", r2: "#0007003D", r2Index: 4 },
        { r1: "key_f5", r2: "#0007003E", r2Index: 5 },
        { r1: "key_f6", r2: "#0007003F", r2Index: 6 },
        { r1: "key_f7", r2: "#00070040", r2Index: 7 },
        { r1: "key_f8", r2: "#00070041", r2Index: 8 },
        { r1: "key_f9", r2: "#00070042", r2Index: 9 },
        { r1: "key_f10", r2: "#00070043", r2Index: 10 },
        { r1: "key_f11", r2: "#00070044", r2Index: 11 },
        { r1: "key_f12", r2: "#00070045", r2Index: 12 },
        { r1: "key_delete", r2: "#0007004C", r2Index: 13 },
        { r1: "key_home", r2: "#0007004A", r2Index: 14 },

        { r1: "key_GAT", r2: "#00070035", r2Index: 25 },
        { r1: "key_1", r2: "#0007001E", r2Index: 26 },
        { r1: "key_2", r2: "#0007001F", r2Index: 27 },
        { r1: "key_3", r2: "#00070020", r2Index: 28 },
        { r1: "key_4", r2: "#00070021", r2Index: 29 },
        { r1: "key_5", r2: "#00070022", r2Index: 30 },
        { r1: "key_6", r2: "#00070023", r2Index: 31 },
        { r1: "key_7", r2: "#00070024", r2Index: 32 },
        { r1: "key_8", r2: "#00070025", r2Index: 33 },
        { r1: "key_9", r2: "#00070026", r2Index: 34 },
        { r1: "key_0", r2: "#00070027", r2Index: 35 },
        { r1: "key_mis", r2: "#0007002D", r2Index: 36 },
        { r1: "key_equ", r2: "#0007002E", r2Index: 37 },
        { r1: "key_backspace", r2: "#0007002A", r2Index: 38 },
        { r1: "key_end", r2: "#0007004D", r2Index: 39 },

        { r1: "key_tab", r2: "#0007002B", r2Index: 50 },
        { r1: "key_q", r2: "#00070014", r2Index: 51 },
        { r1: "key_w", r2: "#0007001A", r2Index: 52 },
        { r1: "key_e", r2: "#00070008", r2Index: 53 },
        { r1: "key_r", r2: "#00070015", r2Index: 54 },
        { r1: "key_t", r2: "#00070017", r2Index: 55 },
        { r1: "key_y", r2: "#0007001C", r2Index: 56 },
        { r1: "key_u", r2: "#00070018", r2Index: 57 },
        { r1: "key_i", r2: "#0007000C", r2Index: 58 },
        { r1: "key_o", r2: "#00070012", r2Index: 59 },
        { r1: "key_p", r2: "#00070013", r2Index: 60 },
        { r1: "key_oqo", r2: "#0007002F", r2Index: 61 },
        { r1: "key_eqo", r2: "#00070030", r2Index: 62 },
        { r1: "key_bsl", r2: "#00070031", r2Index: 63 },
        { r1: "key_pgup", r2: "#0007004B", r2Index: 64 },

        { r1: "key_cap", r2: "#00070039", r2Index: 75 },
        { r1: "key_a", r2: "#00070004", r2Index: 76 },
        { r1: "key_s", r2: "#00070016", r2Index: 77 },
        { r1: "key_d", r2: "#00070007", r2Index: 78 },
        { r1: "key_f", r2: "#00070009", r2Index: 79 },
        { r1: "key_g", r2: "#0007000A", r2Index: 80 },
        { r1: "key_h", r2: "#0007000B", r2Index: 81 },
        { r1: "key_j", r2: "#0007000D", r2Index: 82 },
        { r1: "key_k", r2: "#0007000E", r2Index: 83 },
        { r1: "key_l", r2: "#0007000F", r2Index: 84 },
        { r1: "key_COL", r2: "#00070033", r2Index: 85 },
        { r1: "key_CC", r2: "#00070034", r2Index: 86 },
        { r1: "key_enter", r2: "#00070028", r2Index: 88 },
        { r1: "key_pgdn", r2: "#0007004E", r2Index: 89 },

        { r1: "key_shift_l", r2: "#000700E1", r2Index: 100 },
        { r1: "key_z", r2: "#0007001D", r2Index: 102 },
        { r1: "key_x", r2: "#0007001B", r2Index: 103 },
        { r1: "key_c", r2: "#00070006", r2Index: 104 },
        { r1: "key_v", r2: "#00070019", r2Index: 105 },
        { r1: "key_b", r2: "#00070005", r2Index: 106 },
        { r1: "key_n", r2: "#00070011", r2Index: 107 },
        { r1: "key_m", r2: "#00070010", r2Index: 108 },
        { r1: "key_CMA", r2: "#00070036", r2Index: 109 },
        { r1: "key_DOT", r2: "#00070037", r2Index: 110 },
        { r1: "key_SL", r2: "#00070038", r2Index: 111 },
        { r1: "key_shift_r", r2: "#000700E5", r2Index: 112 },
        { r1: "key_up", r2: "#00070052", r2Index: 113 },

        { r1: "key_ctrl_l", r2: "#000700E0", r2Index: 125 },
        { r1: "key_win_l", r2: "#000700E3", r2Index: 126 },
        { r1: "key_alt_l", r2: "#000700E2", r2Index: 127 },
        { r1: "key_space", r2: "#0007002C", r2Index: 131 },
        { r1: "KEY_FN", r2: "#00920C0B", r2Index: 135 },
        { r1: "key_ctrl_r", r2: "#000700E4", r2Index: 136 },
        { r1: "key_left", r2: "#00070050", r2Index: 137 },
        { r1: "key_down", r2: "#00070051", r2Index: 138 },
        { r1: "key_right", r2: "#0007004F", r2Index: 139 },

        { r1: "key_app", r2: "#00070065", r2Index: -1 },
        { r1: "key_print", r2: "#00070046", r2Index: -1 },
        { r1: "key_scroll", r2: "#00070047", r2Index: -1 },
        { r1: "key_pause", r2: "#00070048", r2Index: -1 },
        { r1: "key_insert", r2: "#00070049", r2Index: -1 },
        { r1: "key_numlock", r2: "#00070053", r2Index: -1 },
        { r1: "key_num_PADNSL", r2: "#00070054", r2Index: -1 },
        { r1: "key_num_PADNMU", r2: "#00070055", r2Index: -1 },
        { r1: "key_num_PADNMI", r2: "#00070056", r2Index: -1 },
        { r1: "key_num_PADNPL", r2: "#00070057", r2Index: -1 },
        { r1: "key_num_enter", r2: "#00070058", r2Index: -1 },
        { r1: "key_num_1", r2: "#00070059", r2Index: -1 },
        { r1: "key_num_2", r2: "#0007005A", r2Index: -1 },
        { r1: "key_num_3", r2: "#0007005B", r2Index: -1 },
        { r1: "key_num_4", r2: "#0007005C", r2Index: -1 },
        { r1: "key_num_5", r2: "#0007005D", r2Index: -1 },
        { r1: "key_num_6", r2: "#0007005E", r2Index: -1 },
        { r1: "key_num_7", r2: "#0007005F", r2Index: -1 },
        { r1: "key_num_8", r2: "#00070060", r2Index: -1 },
        { r1: "key_num_9", r2: "#00070061", r2Index: -1 },
        { r1: "key_num_0", r2: "#00070062", r2Index: -1 },
        { r1: "key_num_del", r2: "#00070063", r2Index: -1 },
        { r1: "key_alt_r", r2: "#000700E6", r2Index: -1 },
        { r1: "key_win_r", r2: "#000700E7", r2Index: -1 },

        { r1: "key_local_key_fun_switch_left", r2: "#00920C0D", r2Index: -1 },
        { r1: "key_led_cmd_on_off_led", r2: "#00920101", r2Index: -1 },
        { r1: "key_led_cmd_next_page", r2: "#00920100", r2Index: -1 },
        { r1: "key_led_cmd_lightness_add", r2: "#00920102", r2Index: -1 },
        { r1: "key_led_cmd_lightness_reduce", r2: "#00920103", r2Index: -1 },
        { r1: "key_led_cmd_speed_add", r2: "#00920104", r2Index: -1 },
        { r1: "key_led_cmd_speed_reduce", r2: "#00920105", r2Index: -1 },
        { r1: "key_local_key_mode_cmd_on_off", r2: "#00920903", r2Index: -1 },
        { r1: "key_local_key_next_mode", r2: "#00920900", r2Index: -1 },
        {
          r1: "key_local_key_mode_lightness_add",
          r2: "#00920901",
          r2Index: -1,
        },
        {
          r1: "key_local_key_mode_lightness_reduce",
          r2: "#00920902",
          r2Index: -1,
        },
        { r1: "key_led_cmd_ble_shfit1", r2: "#00920106", r2Index: -1 },
        { r1: "key_led_cmd_ble_shfit2", r2: "#00920107", r2Index: -1 },
        { r1: "key_led_cmd_ble_shfit3", r2: "#00920108", r2Index: -1 },
        { r1: "key_led_cmd_ble_2_4g", r2: "#00920130", r2Index: -1 },
        { r1: "key_led_cmd_factory_reset", r2: "#00920A02", r2Index: -1 },

        { r1: "key_cmd_set_key_layer1", r2: "#00920C0F", r2Index: -1 },
        { r1: "key_cmd_set_key_layer2", r2: "#00920C10", r2Index: -1 },
        { r1: "key_cmd_set_key_layer3", r2: "#00920C11", r2Index: -1 },
        { r1: "key_cmd_set_key_layer4", r2: "#00920C12", r2Index: -1 },
        { r1: "key_cmd_set_key_layer5", r2: "#00920C13", r2Index: -1 },
        { r1: "key_cmd_set_key_layer6", r2: "#00920C14", r2Index: -1 },
        { r1: "key_cmd_set_key_layer7", r2: "#00920C15", r2Index: -1 },

        { r1: "key_hold_set_key_layer1", r2: "#00920C20", r2Index: -1 },
        { r1: "key_hold_set_key_layer3", r2: "#00920C22", r2Index: -1 },
        { r1: "key_hold_set_key_layer4", r2: "#00920C23", r2Index: -1 },
        { r1: "key_hold_set_key_layer5", r2: "#00920C24", r2Index: -1 },
        { r1: "key_hold_set_key_layer6", r2: "#00920C25", r2Index: -1 },
        { r1: "key_hold_set_key_layer7", r2: "#00920C26", r2Index: -1 },

        { r1: "key_media_mute", r2: "#000C00E2", r2Index: -1 },
        { r1: "key_media_volume_up", r2: "#000C00E9", r2Index: -1 },
        { r1: "key_media_volume_down", r2: "#000C00EA", r2Index: -1 },
        { r1: "key_media_prev_track", r2: "#000C00B6", r2Index: -1 },
        { r1: "key_media_next_track", r2: "#000C00B5", r2Index: -1 },
        { r1: "key_media_play_pause", r2: "#000C00CD", r2Index: -1 },

        { r1: "key_led_cmd_power", r2: "#00920A01", r2Index: -1 },
      ];

      let layer_data = [];

      for (let index = 0; index < 7; index++) {
        const key = "keyboardSettings" + (index || "");
        if (data[key]) {
          const layer = [];

          while (layer.length < 200) {
            layer.push("#00000000");
          }

          keyList.map((key) => {
            if (key.r2Index > -1) {
              layer[key.r2Index] = key.r2;
            }
          });

          const keys = data[key].filter(
            (key) => key.srcKey !== key.dstKey && typeof key.srcKey === "string"
          );

          keys.map((key) => {
            const input = keyList.find((keyItem) => keyItem.r1 === key.srcKey);
            const out = keyList.find((keyItem) => keyItem.r1 === key.dstKey);
            layer[input.r2Index] = out.r2;
          });

          layer_data.push({ layer });
        }
      }

      return {
        "//":
          "键层设置，按键矩阵大小预留为25*8，各个产品类型的键盘自定义矩阵数据位置",
        valid: true,
        layer_num: layer_data.length,
        layer_data,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.c-profile-download {
  @include flex-center;
  width: 900px;
  flex-direction: column;
  margin: 0 auto;
  position: relative;

  .title {
    font-size: 24px;
    color: #ffffff;
    margin-bottom: 60px;
  }

  .r1,
  .r2 {
    width: 840px;
    height: 245px;
    border: 2px solid $primary-color;
    border-radius: 10px;
    margin-bottom: 25px;
    background: no-repeat center center / cover;
    position: relative;
    cursor: pointer;

    .download {
      @include flex-center;
      width: 100%;
      height: 100%;
      background: rgba($color: $primary-color, $alpha: 0.4);
      display: none;

      i {
        font-size: 60px;
        color: #ffffff;
      }
    }

    &:hover {
      .download {
        display: flex;
      }
    }
  }

  .text {
    font-size: 12px;
    color: #ffffff;
    margin-bottom: 60px;
  }

  .buttons {
    @include flex-center;
    width: 100%;
    margin-top: 10px;

    .button {
      width: 150px;
      height: 53px;
      background-color: $active-color;
      border-radius: 5px;
      font-size: 20px;
      text-transform: none;

      & + .button {
        margin-left: 100px;
      }
    }
  }
}

.c-select {
  @include flex-center;
  width: 900px;
  flex-direction: column;
  margin: 0 auto;
  position: relative;

  .title {
    font-size: 24px;
    color: #ffffff;
    margin-bottom: 30px;
  }

  .checkbox {
    width: 230px;
    font-size: 20px;
    color: #ffffff;
    margin: 0 auto 30px auto;
  }

  .buttons {
    @include flex-center;
    width: 100%;
    margin-top: 10px;

    .button {
      width: 150px;
      height: 53px;
      background-color: $active-color;
      border-radius: 5px;
      font-size: 20px;
      text-transform: none;

      & + .button {
        margin-left: 100px;
      }
    }
  }

  &.cn .checkbox {
    width: 160px;
  }
}
</style>
